import PageLayout from "components/PageLayout";

import "./style.scss";

const Contact = () => {
  return (
    <PageLayout pageTitle={"Contact"}>

      <div className="row justify-content-center">
        <div className="col-12 text-center" style={{ fontSize: "1.25rem", fontWeight: "300" }}>
          <h4 className="mb-2">Address:</h4>
          <p className="lead mb-3">
            5 Shoreham Drive <br />
            Toronto, ON <br />
            M3N 1S4
          </p>
          <br></br>
          <h4 className="mb-2">E-mail:</h4>
          <p className="lead">step@trca.ca</p>
        </div>
      </div>
    </PageLayout>
  );
};

export default Contact;
